import Header from '../utill/Header';
import Footer from '../utill/Footer';
import Sidebar from '../utill/Sidebar';
import React, {useContext, useEffect, useState} from "react";
import {Button, Card, Form, Table} from "react-bootstrap";
import {Link, useNavigate} from "react-router-dom";
import Url from "../utill/Url";
import axios from "axios";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import {
    Paper,
    TableBody,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {RootState} from "../../redux/store";
import StyledTableCell from "../utill/StyledTableCell"

function AuthorityManagement() {

    const url = useContext(Url);
    const navigate = useNavigate();
    const [data, setData] = useState<AuthorityName[]>([]);
    const [searchText, setSearchText] = useState('');
    const user = useSelector((state: RootState) => state.user.value);
    const auth = useSelector((state: RootState) => state.loginAuth.value);
    const [writeAuthorityYn, setWriteAuthorityYn] = useState(false);

    let userId = user.id;

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-권한 관리'
        if (auth.MENUAUTH?.SET0100?.readAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        setWriteAuthorityYn(auth.MENUAUTH?.SET0100?.writeAuthorityYn === "1")
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'authority/findall ', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
                .then((response) => {
                    setData(response.data.result.data)
                })
        })
    }, []);

    const handleSubmit = async () => {
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'authority/find', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    data: searchText,
                    type: 2
                }
            })
                .then((response) => {
                    setData(response.data.result.data)
                })
        })
    }

    const handleAddClick = () => {
        navigate('/AuthorityAdd')
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const key = e.code;
        if (key === 'Enter' || key === 'NumpadEnter') {
            e.preventDefault();
        }
    }

    

    return (
        <div id="wrapper">
            <Sidebar menuCode={"SET0100"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='권한 관리'/>
                        <p className="header-message">웹 사이트의 권한을 관리합니다. 해당 권한 명, 설명을 클릭하면 정보를 수정, 삭제 할 수 있습니다.</p>
                        <br/>
                        <Card className="card shadow mb-4" style={{minHeight: "670px"}}>
                            <Card.Header className="py-3">
                                <Form id="searchForm">
                                    <div className="form-group row">
                                        <Form.Control type="text" placeholder="권한 명" onKeyDown={handleKeyDown} value={searchText}
                                                      onChange={(e) => setSearchText(e.target.value)}
                                        />
                                        <div className="search_button_area">
                                            <Button variant="primary" className="search_button"
                                                    onClick={handleSubmit}>검색</Button>
                                            {writeAuthorityYn && <Button className="search_button" style={{marginLeft:'1rem'}} onClick={handleAddClick}>권한 등록</Button>}
                                        </div>
                                    </div>
                                </Form>
                            </Card.Header>
                            <Card.Body>
                                <TableContainer component={Paper}>
                                    <Table style={{marginBottom: 0}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="center">권한 명</StyledTableCell>
                                                <StyledTableCell align="center">설명</StyledTableCell>
                                                <StyledTableCell align="center">삭제 여부</StyledTableCell>
                                                <StyledTableCell align="center">삭제 일시</StyledTableCell>
                                                <StyledTableCell align="center">등록자</StyledTableCell>
                                                <StyledTableCell align="center">등록일시</StyledTableCell>
                                                <StyledTableCell align="center">수정자</StyledTableCell>
                                                <StyledTableCell align="center">수정일시</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        {writeAuthorityYn ? (<TableBody>
                                            {data.map(authority => (
                                                <TableRow component={Link} to='/AuthorityModify' className='custom-link' state={{ id: authority.authorityId }}
                                                          key={authority.authorityId} sx={{
                                                    '&:hover td': {
                                                        backgroundColor: 'rgba(0,111,255,0.13)'
                                                    },
                                                    '&:active td': {
                                                        backgroundColor: 'rgba(0,149,255,0.13)'
                                                    }
                                                }}>
                                                    <StyledTableCell align="center">{authority.authorityName || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{authority.description || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{authority.deleteYn === "0" ? "사용중" : "삭제됨"}</StyledTableCell>
                                                    <StyledTableCell align="center">{authority.deleteDtm ? authority.deleteDtm.replace('T', ' ') : "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{authority.registerUser || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{authority.registerDtm.replace('T', ' ') || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{authority.updateUser || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{authority.updateDtm.replace('T', ' ') || "-"}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>):(<TableBody>
                                        {data.map(authority => (
                                            <TableRow key={authority.authorityId} sx={{
                                        '&:hover td': {
                                            backgroundColor: 'rgba(0,111,255,0.13)'
                                        },
                                        '&:active td': {
                                            backgroundColor: 'rgba(0,149,255,0.13)'
                                        }
                                    }}>
                                                <StyledTableCell align="center">{authority.authorityName || "-"}</StyledTableCell>
                                                <StyledTableCell align="center">{authority.description || "-"}</StyledTableCell>
                                                <StyledTableCell align="center">{authority.deleteDtm ? authority.deleteDtm.replace('T', ' ') : "-"}</StyledTableCell>
                                                <StyledTableCell align="center">{authority.registerUser || "-"}</StyledTableCell>
                                                <StyledTableCell align="center">{authority.registerDtm.replace('T', ' ') || "-"}</StyledTableCell>
                                                <StyledTableCell align="center">{authority.updateUser || "-"}</StyledTableCell>
                                                <StyledTableCell align="center">{authority.updateDtm.replace('T', ' ') || "-"}</StyledTableCell>
                                    </TableRow>
                                    ))}
                                </TableBody>)}
                                    </Table>
                                </TableContainer>
                            </Card.Body>
                        </Card>
                        <div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}


export default AuthorityManagement;